import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspRedeemItemService {

  constructor( private http: HttpClient,) {}
  getCategories(){
    // console.log('-----Get categories Details-----------');    
    return this.http.get(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/wallet/redeem/categories');
  }
  redeemSpare(categories,subCategories) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      garageKey: localStorage.getItem("garageKey"),
      categories: [categories],
      subCategories:subCategories

    };

    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}` + '/spare/wallet/spareRedeem', body, { headers });
  }
}
